import { Card, CardContent, CardMedia, Typography, Box } from "@mui/material";
import LockIcon from "@mui/icons-material/Lock"; // 錠前アイコン
import ChiQuestClearedChip from "./QuestClearedChip";
import { COLORS } from "constants/colors";

export default function ChiQuestCard({ quest, onClick }) {
  return (
    <Card
      sx={{
        display: "flex",
        maxWidth: 600,
        width: "100%",
        position: "relative",
        overflow: "hidden",
        backgroundColor: "rgba(0, 0, 0, 0.5)",
        boxShadow: "0px 0px 4px rgba(200, 200, 200, 0.5)",
      }}
      onClick={onClick}
    >
      {quest.is_locked && (
        <div
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundColor: "rgba(255, 255, 255, 0.2)", // 黒い透明レイヤー
            backdropFilter: "blur(16px)", // ここで背景をぼかす
            WebkitBackdropFilter: "blur(16px)", // Safari対応
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 1, // レイヤーを上に配置
          }}
        >
          <LockIcon style={{ color: "white", fontSize: 50 }} />
        </div>
      )}
      <CardMedia
        component="img"
        sx={{ width: "50%", maxWidth: 200, minHeight: 160, objectFit: "cover" }}
        image={quest.eye_catch_url}
        alt="Image description"
      />
      <CardContent
        sx={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          padding: 2,
          flex: 1,
        }}
      >
        <Typography
          variant="h6"
          sx={{
            fontFamily: '"Noto Serif JP", serif',
            fontWeight: 700,
            fontSize: "17px",
            color: COLORS.TEXT_WHITE,
            textAlign: "center",
          }}
        >
          {quest.name}
        </Typography>

        <Typography
          variant="h6"
          sx={{
            fontFamily: '"Noto Serif JP", serif',
            fontSize: "12px",
            fontWeight: "text.secondary",
            color: COLORS.TEXT_WHITE,
            textAlign: "center",
            mt: 1,
          }}
        >
          {quest.description}
        </Typography>

        {(!quest.is_expired || quest.is_cleared) && (
          <Box mt={2}>
            <ChiQuestClearedChip isCleared={quest.is_cleared} />
          </Box>
        )}
      </CardContent>
    </Card>
  );
}
